module.exports = new __parcel__URL__("empty-automation-list.9c7d0496.png").toString();